import { render, staticRenderFns } from "./PdvOrderBillForm.vue?vue&type=template&id=0ba48c47"
import script from "./PdvOrderBillForm.vue?vue&type=script&lang=js"
export * from "./PdvOrderBillForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports